import gql from 'graphql-tag'

export const GET_USER = gql`
  query {
    usuario {
      nome
      sobrenome
      apelido
      email
      modulos
    }
  }
`
